import { featureCollection } from "@turf/helpers";


export function eMapSource(data) {
    if (Array.isArray(data)) {
        return {
            type: 'geojson',
            data: featureCollection(data)
        };
    }
    if ("type" in data && data.type === "Feature") {
        return {
            type: 'geojson',
            data: featureCollection([data])
        };
    }
    if ("type" in data && data.type === "FeatureCollection") {
        return {
            type: 'geojson',
            data: data
        };
    }
    return {
        type: 'geojson',
        data: featureCollection([])
    };
}
export function eMapLayerOutline(id, source, color) {
    return {
        id: id,
        type: 'line',
        source: source,
        paint: {
            'line-color': color,
            'line-width': 2
        }
    };
}
export function eMapLayerFill(id, source, color, opacity?: number) {
    return {
        id: id,
        type: 'fill',
        source: source,
        paint: {
            'fill-color': color,
            'fill-opacity': opacity ?? 0.5
        }
    };
}

export function eMapLayerTextSymbol(id, source, field) {
    return {
        id: id,
        type: 'symbol',
        source: source,
        layout: {
            'text-field': ['get', field],
            'text-font': ["Noto Sans Regular"],
            'text-size': 11,
            'text-allow-overlap': false,
            'text-ignore-placement': true,
        },
        paint: {
            // "text-halo-blur": 1,
            "text-halo-width": 1.5,
            "text-color": "#222",
            "text-halo-color": "rgba(255,255,255,1)"
        }
    };
}